import { IonResource, Resource } from "cesium";
import { AssetType } from "../types";
const TileAssetResource = {
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    fromAssetId: async (assetId, version, accessToken, server, type) => {
        const endpointUrl = new URL(`/v1/asset/${assetId}/${version}`, server);
        const resource = new Resource({
            url: endpointUrl.toString(),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                withCredentials: false,
            },
        });
        try {
            const jsonResponse = await resource.fetchJson();
            if (!jsonResponse) {
                throw new Error("Failed to fetch asset endpoint");
            }
            if (type === AssetType.Point_Cloud) {
                return new IonResource(jsonResponse, resource).getDerivedResource({
                    url: "pntsTileset.json",
                });
            }
            else if (type === AssetType.Design_Data) {
                return new IonResource(jsonResponse, resource);
            }
        }
        catch (error) {
            console.error("Error fetching asset resource:", error);
            throw error;
        }
    },
};
export { TileAssetResource };
//# sourceMappingURL=TileAssetResource.js.map